import { render, staticRenderFns } from "./AllowConditionalDonations.vue?vue&type=template&id=dab8706c&scoped=true&"
import script from "./AllowConditionalDonations.vue?vue&type=script&lang=js&"
export * from "./AllowConditionalDonations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab8706c",
  null
  
)

export default component.exports